<mat-card  *ngIf="order" appearance="outlined">
    <mat-card-header>
        <mat-card-title>Order Details</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <p>Animal Name: {{order.animalName}}</p>
        <p>Animal Type: {{order.animalType.name}}</p>
        <p>Pickup from: {{order.pickupLocation.address.street}} <span *ngIf="order.pickupFromClinic"> - {{order.clinic.name}}</span></p>
        <p>Dropoff to: {{order.dropOffLocation.address.street}} <span *ngIf="order.dropOffToClinic"> - {{order.clinic.name}}</span></p>
    </mat-card-content>
</mat-card>